import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import Image from "next/image";
import { formatFocusArea } from "../../utils/formatFocusArea";
import { IMAGE_QUALITY_MOBILE } from "@/lib/heroImageUtils";
export interface ContentfulImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  fit?: string;
  placement?: string;
  focusArea?: string;
  componentImagePriority?: "high" | "auto" | "low";
}
export const RenderContentfulImage = props => {
  const $ = _c(14);
  const {
    src,
    alt,
    width,
    height,
    className: t0,
    fit: t1,
    placement: t2,
    focusArea,
    componentImagePriority
  } = props;
  const className = t0 === undefined ? "" : t0;
  const _fit = t1 === undefined ? "fill" : t1;
  t2 === undefined ? "center" : t2;
  let t3;
  if ($[0] !== _fit || $[1] !== focusArea || $[2] !== height || $[3] !== src || $[4] !== width) {
    const focusParam = focusArea ? formatFocusArea(focusArea) : null;
    const buildSrc = () => {
      const params = new URLSearchParams();
      if (width) {
        params.set("w", String(width));
      }
      if (height) {
        params.set("h", String(height));
      }
      params.set("fit", _fit);
      params.set("q", "100");
      if (focusParam) {
        params.set("f", focusParam);
      }
      const base = src.startsWith("http") ? src : `https:${src}`;
      return `${base}?${params.toString()}`;
    };
    t3 = buildSrc();
    $[0] = _fit;
    $[1] = focusArea;
    $[2] = height;
    $[3] = src;
    $[4] = width;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const imageSrc = t3;
  const sizes = width ? `(max-width: 640px) 100vw, ${width}px` : undefined;
  const t4 = alt || "";
  let t5;
  if ($[6] !== className || $[7] !== componentImagePriority || $[8] !== height || $[9] !== imageSrc || $[10] !== sizes || $[11] !== t4 || $[12] !== width) {
    t5 = <><Image src={imageSrc} alt={t4} width={width} height={height} className={className} quality={IMAGE_QUALITY_MOBILE} sizes={sizes} fetchPriority={componentImagePriority} /></>;
    $[6] = className;
    $[7] = componentImagePriority;
    $[8] = height;
    $[9] = imageSrc;
    $[10] = sizes;
    $[11] = t4;
    $[12] = width;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};